<template>
  <div class="createProrram">
    <div @click="getScene" style="height: calc(100% - 50PX)">
      <div class="top">
        <div>
          <van-button icon="arrow-left" size="small" @click="back" type="info"/>
          <span style="display: inline-block;width: 5px"></span>
          <van-button type="danger" size="small" @click="emptyCanvns">清空</van-button>
          <span style="display: inline-block;width: 5px"></span>
          <van-button type="danger" size="small" @click="delecontrol" :disabled="disabled">删除</van-button>
          <span style="display: inline-block;width: 5px"></span>
          <van-button type="info" size="small" @click="submit(()=>{})">保存</van-button>
        </div>
        <van-button type="info" size="small" color="#ffa000" @click="submit(gotoa)">发送</van-button>
      </div>
      <div id="canvas" class="canvas">
        <div id="image" :style="{
          backgroundImage: `url(${backUrl})`,
          backgroundSize: '100% 100%'
        }">
          <vdr :h="parseFloat(items.infoHeight) / zoom" :w="parseFloat(items.infoWidth) / zoom" v-on:dragging="onDrag"
               :y="parseFloat(items.infoY) / zoom" @activated="onActivated" :imgType="items.coType"
               :x="parseFloat(items.infoX) / zoom" :index="index" v-show="!dels.includes(items.id)" :id="items.id"
               :ref="'draggable' + index"
               v-on:resizing="onResize" :parent="true" v-for="(items,index) in componentsList" :key="index">
            <div class="resizable-content" v-if="items.coType === 'img'">
              <img :src="upFileUrl + item.url" class="img-content"
                   v-for="(item,index) in items.mpList"
                   :key="index"/>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'subtitle'" v-for="(item,index) in items.txList"
                 :key="index"
                 :style="{'backgroundColor':item.taBgColor,'color':item.taColor,'fontSize':item.taFontSize + 'px'}">
              <div class="text-content">{{ item.taContent }}</div>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'video'">
              <img :src="upFileUrl + item.viewUrl" style="width: 100%;height: 100%;"
                   @error="errImg(item)"
                   v-for="(item,index) in items.mpList"
                   :key="index"/>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'streaming'" v-for="(item,index) in items.txList"
                 :key="index"
                 :style="{'backgroundColor':item.taBgColor,'color':item.taColor,'fontSize':item.taFontSize + 'px'}">
              <div class="text-content">
                <img src="/static/images/liumeiti.jpg" style="width: 100%;height: 100%;"
                     v-if="item.taContent !== ''"/>
              </div>
            </div>
            <div class="resizable-content" v-else-if="items.coType === 'webPage'" v-for="(item,index) in items.txList"
                 :key="index"
                 :style="{'backgroundColor':item.taBgColor,'color':item.taColor,'fontSize':item.taFontSize + 'px'}">
              <div class="text-content">
                <img src="/static/images/web.jpg" v-if="item.taContent !== ''"/>
              </div>
            </div>
          </vdr>
        </div>
      </div>
      <control @addControl="addControl" @addbackground='addbackground'></control>
    </div>

    <imgsettings v-if="imgsetting" @fullscreen="fullscreen" @addimg="showImgList"/>
    <showImgList :lists="componentsList[controlIndex].mpList" v-if="isImgList" @ondele="ondele"
                 @clear="clear"/>
    <videosettings v-if="videosetting" @fullscreen="fullscreen" @addVideo="showAddVideo"/>
    <showVideoList :lists="componentsList[controlIndex].mpList" v-if="isVideoList" @ondele="ondele"
                   @clear="clear"/>
    <fontsettings v-if="subtitlesetting" @fullscreen="fullscreen" @edit="showText"/>
    <addText v-if="isText" @setText="getText" @close="close"
             :text="componentsList[controlIndex]"></addText>
    <websettings v-if="websetting" @fullscreen="fullscreen" @edit="showText"/>
    <addBackground @setImages='setBackImage' v-if="isBack" @close="close"/>
    <hdmisetting @fullscreen="fullscreen" v-if="hdmin"/>
    <van-overlay :show="show1">
      <div style="height: 100%;display: flex;justify-content: center;align-items: center">
        <van-loading size="24px" style="color: #F8F9FD">加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import vdr from '../components/vue-draggable-resizable'
import qs from 'qs'
import control from '../components/control'
import imgsettings from '../components/imgsettings'
import hdmisetting from "../components/hdmisetting";
import showImgList from '../components/showImgList'
import showVideoList from '../components/showVideoList'
import fontsettings from '../components/fontsettings'
import videosettings from '../components/videosettings'
import addText from '../components/addText'
import websettings from '../components/websettings'
import addBackground from '../components/addBackground'
import {mapActions, mapState} from 'vuex'
import {Dialog, Toast} from 'vant'

export default {
  name: 'createProrram',
  inject: ['reload'],
  data() {
    return {
      pmId: this.$route.query.id,
      mainResolutionW: 0,
      mainResolutionH: 0,
      zoom: 1,
      imgsetting: false,
      videosetting: false,
      subtitlesetting: false,
      websetting: false,
      hdmin: false,
      isImgList: false,
      isVideoList: false,
      isText: false,
      isBack: false,
      show1: false,
      disabled: true,
      type: 'add',
      prmgremMsg: [],
      width: 0,
      height: 0
    }
  },
  mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    this.width = document.getElementById('canvas').offsetWidth
    this.$nextTick(() => {
      document.getElementById('canvas').style.height = `${this.width}px`
    })

    this.$ajax.post('/etv/selectPhoneProgramMould.json', qs.stringify({
      pmId: this.pmId,
    })).then(res => {
      if (res.data.code === 0) {
        document.title = "创建节目"
        const resolution = res.data.data.pmResolution
        this.mainResolutionW = parseInt(resolution.split('*')[0])
        this.mainResolutionH = parseInt(resolution.split('*')[1])

        this.getZoom()
        this.$store.state.componentsList = res.data.data.sceneList[0].componentsList
        this.$store.state.backUrl = this.upFileUrl + res.data.data.sceneList[0].scBackImg
        this.$store.state.sceneList = res.data.data.sceneList[0]
        this.componentsList.map(res => {
          res.infoX = res.coLeftPosition
          res.infoY = res.coRightPosition
          res.infoWidth = res.coWidth
          res.infoHeight = res.coHeight
        })
        this.prmgremMsg = [res.data.data]
      }
    })
  },
  methods: {
    ...mapActions(['addControl', 'addSubtitle', 'emptyCanvns', 'addBackground']),
    onResize: function (x, y, width, height) {
      this.componentsList[this.controlIndex].coHeight = height * this.zoom
      this.componentsList[this.controlIndex].coWidth = width * this.zoom
      this.componentsList[this.controlIndex].coLeftPosition = x * this.zoom
      this.componentsList[this.controlIndex].coRightPosition = y * this.zoom
    },
    onDrag: function (x, y) {
      this.componentsList[this.controlIndex].coLeftPosition = x * this.zoom
      this.componentsList[this.controlIndex].coRightPosition = y * this.zoom
    },
    getZoom() {
      if (this.mainResolutionW / this.mainResolutionH > 1) {
        this.zoom = this.mainResolutionW / this.width
        document.getElementById('image').style.height = this.mainResolutionH / this.zoom + 'px'
      } else {
        document.getElementById('image').style.height = '100%'
        this.zoom = this.mainResolutionH / this.width
        document.getElementById('image').style.width = this.mainResolutionW / this.zoom + 'px'
      }
      console.log(this.mainResolutionW);
      console.log(this.width);
      console.log(this.zoom)
    },
    addbackground() {
      this.isBack = true
    },
    onActivated(left, top, width, height, index, type) {
      this.$store.state.controlIndex = index
      this.disabled = false
      if (type === 'img') {
        this.imgsetting = true
        this.videosetting = false
        this.subtitlesetting = false
        this.websetting = false
        this.hdmin = false
      } else if (type === 'video') {
        this.videosetting = true
        this.imgsetting = false
        this.subtitlesetting = false
        this.websetting = false
        this.hdmin = false
      } else if (type === 'subtitle') {
        this.subtitlesetting = true
        this.videosetting = false
        this.imgsetting = false
        this.websetting = false
        this.hdmin = false
      } else if (type === 'hdmin') {
        this.subtitlesetting = false
        this.videosetting = false
        this.imgsetting = false
        this.websetting = false
        this.hdmin = true
      } else {
        this.subtitlesetting = false
        this.videosetting = false
        this.imgsetting = false
        this.websetting = true
        this.hdmin = false
      }

    },
    showImgList() {
      this.isImgList = true
    },
    showAddVideo() {
      this.isVideoList = true
    },
    getScene() {
      this.disabled = true
      this.imgsetting = false
      this.videosetting = false
      this.subtitlesetting = false
      this.websetting = false
      this.hdmin = false
    },
    ondele(index) {
      this.componentsList[this.controlIndex].mpList.splice(index, 1)
    },
    clear() {
      this.isVideoList = false
      this.isImgList = false
    },
    showText() {
      this.isText = true
    },
    close() {
      this.isText = false
      this.isBack = false
    },
    getText(data) {
      this.isText = false
      this.addSubtitle({
        type: this.controlType,
        data,
      })
    },
    setBackImage(data) {
      this.isBack = false
      this.addBackground(data)
    },
    gotoa(url, query) {
      this.$router.push({
        path: url,
        query,
      })
    },
    back() {
      Dialog.confirm({
        message: '确定离开此页面？'
      }).then(() => {
        this.$router.back()
      }).catch(() => {
        // on cancel
      })

    },
    delecontrol() {
      this.dels.push(this.componentsList[this.controlIndex].id)
    },
    submit(callback) {
      let obj = {}
      obj.pmId = this.sceneList.scPmId
      obj.backImg = this.sceneList.scBackImg
      obj.backImgId = this.sceneList.scBackImgId
      obj.backImgSize = this.sceneList.scBackimgSize
      obj.scTime = this.sceneList.scTime
      obj.sort = this.sceneList.scSort
      obj.scId = this.sceneList.id
      obj.scName = this.sceneList.scName
      obj.type = this.type
      obj.html = 'hello word'
      obj.isSaveBtn = true
      let compents = []

      let data = this.componentsList.filter(res => {
        if (!this.dels.includes(res.id)) {
          return true
        }
      })


      for (let i = 0; i < data.length; i++) {
        let materials = []
        console.log(data[i].coType);
        if (['subtitle', 'webPage', 'streaming','hdmin'].includes(data[i].coType)) {
          data[i].txList.map(res => {
            if (res.taContent === '') {
              Toast('请给控件添加内容')
              return
            }
            materials.push({
              'color': res.taColor, // 颜色
              'content': res.taContent, // 内容
              'fontSize': res.taFontSize, // 长度
              'move': res.taMove, // 滚动方向
              'no': 1, // 序号
              'alignment': res.taAlignment, // 对齐方式
              'bgColor': res.taBgColor, // 字幕背景色
              'moveSpeed': res.taMoveSpeed, // 字幕滚动速度
              'difference': 2, // 属性控件 字幕、天气、日期等控件
              'address': '', // 地址
              'countDown': '`',
              "bgImage": "你猜"
            })
          })
        } else {
          data[i].mpList.map(res => {
            materials.push({
              mtId: res.mid,
              playParam: res.playParam,
              difference: '1',
              cartoon: res.cartoon,
              'vol': res.volume,
            })
          })
        }

        if (materials.length === 0 && data[i].coType !== 'hdmin') {
          Toast('请给控件添加内容')
          return
        }
        compents.push({
          'type': data[i].coType,
          'leftPosition': parseFloat(data[i].coLeftPosition),
          'rightPosition': parseFloat(data[i].coRightPosition),
          'width': data[i].coWidth,
          'height': data[i].coHeight,
          'actionType': '',
          'linkAction': '',
          'screenProtectTime': '10',
          'materials': materials,
        })
      }


      if (compents.length === 0) {
        Toast('请添加控件')
        return
      }
      obj.compents = compents
      this.show1 = true
      this.$ajax({
        method: 'post',
        url: '/etv/insertPhoneSceneInfo.json',
        data: obj,
        headers: {
          'content-type': 'application/json',
        },
      }).then(res => {
        if (res.data.code === 0) {
          Toast('保存成功')
          this.show1 = false
          this.$store.state.sceneList.id = res.data.data

          callback && callback(`/addTask`, {
            grogramIds: this.$route.query.id,
            parentPage: 'taskList',
            progremData: this.prmgremMsg
          })

        } else {
          Toast(res.data.msg)
        }
      })
    },
    fullscreen() {
      let sc = 'draggable' + this.controlIndex
      this.$refs[sc][0].fillParent()
    },
    errImg(obj) {
      obj.viewUrl = "static/images/default.png"
      obj.url = "static/images/default.png"
    }
  },
  computed: {
    ...mapState({
      controlIndex: state => state.controlIndex,
      componentsList: state => state.componentsList,
      sceneList: state => state.sceneList,
      backUrl: state => state.backUrl,
      dels: state => state.dels,
    }),
  },
  components: {
    vdr,
    control,
    imgsettings,
    showImgList,
    videosettings,
    showVideoList,
    fontsettings,
    addText,
    websettings,
    addBackground,
    hdmisetting,
  },
}
</script>

<style scoped lang="scss">
.createProrram {
  height: 100%;

  .van-button--small {
    min-width: 10px !important;
  }

  .top {
    padding: 15px;
    display: flex;
    justify-content: space-between;
  }

  .canvas {
    width: calc(100% - 10px);
    margin: 20px auto;
    height: 200px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }

  #image {
    background: #f1f1f1;
    position: relative;
    width: 100%;
  }

  .resizable-content {
    overflow: hidden;
    width: 100%;
    height: 100%;

    .img-content {
      width: 100%;
      height: 100%;
    }

    .text-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }
}
</style>
